
import {Trans} from '@lingui/react/macro'
import {useCallback, useMemo} from 'react'
import {useLingui} from '@lingui/react'
import {useEventCallback} from 'usehooks-ts'

import {useRequireEmailVerification} from '#/lib/hooks/useRequireEmailVerification'
import {useVerificationToast} from '#/lib/hooks/useVerificationToast'
import {useWsocialVerified} from '#/state/session'
import {useOpenComposer as useRootOpenComposer} from '#/state/shell/composer'
import {useWIDUpgradeControl} from '#/components/dialogs/Context'
import * as Toast from '#/components/Toast'

export function useOpenComposer() {
  const {openComposer} = useRootOpenComposer()
  const requireEmailVerification = useRequireEmailVerification()
  const wsocialVerified = useWsocialVerified()
  const widUpgradeControl = useWIDUpgradeControl()
  const {_} = useLingui()
  const checkVerification = useVerificationToast()

  const emailGatedComposer = useMemo(
    () =>
      requireEmailVerification(openComposer, {
        instructions: [
          <Trans key="pre-compose">
            Before creating a post or replying, you must first verify your
            email.
          </Trans>,
        ],
      }),
    [openComposer, requireEmailVerification],
  )

  const gatedOpenComposer = useEventCallback(
    (...args: Parameters<typeof openComposer>) => {
      if (checkVerification('post')) {
        return emailGatedComposer(...args)
      }
    },
  )

  return useMemo(() => ({openComposer: gatedOpenComposer}), [gatedOpenComposer])
}
